import ADACompliantActionButton from './ADACompliantActionButton';
import GlobalVariables from '../GlobalVariables';
import ChatMode from './ChatMode';

const SetADACompliantAttributes = function (container, chatMode, selector) {
    const chatTitle =
        chatMode == ChatMode.DOM
            ? GlobalVariables.DOM_CHAT_TITLE
            : GlobalVariables.WINDOWED_CHAT_TITLE;
    ADACompliantActionButton(container, selector, chatTitle);
};
export default SetADACompliantAttributes;
